module.exports = __webpack_public_path__ + "img/newtaiyo9.80a2aa01.png";